module.exports = __webpack_public_path__ + "img/1007.c0a838c0.png";